import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEqual} from "lodash"

import authentication from "@irati/auth"
import Modal from "@irati/ui/src/Modal"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import {injectIntl} from "@irati/utils/lang"
import {PRIVATE_OPTION, TEAMS_OPTION, EVERYONE_OPTION, TEAMS} from "@irati/recognition/constants/share"
import isShareableWithTeams from "@irati/recognition/utils/isShareableWithTeams"

import Create from "./Create"
import Success from "./Success"
import {CancelConfirm} from "../shared"
import TitleInlineModal from "../shared/layouts/TitleInlineModal"

export const CREATE = "CREATE"
export const CANCEL_CONFIRM = "CANCEL_CONFIRM"
export const SUCCESS = "SUCCESS"

const modals = [CREATE, CANCEL_CONFIRM, SUCCESS]

const EMPTY_RECOGNITION = (formatMessage) => {
  const canShareWithEveryone = authentication.apps("recognition.recognition.everyone")
  return {
    companyValues: [],
    userIds: [],
    teamIds: [],
    isPrivate: true,
    share: canShareWithEveryone ? EVERYONE_OPTION(formatMessage) : TEAMS_OPTION(formatMessage)
  }
}

class CreateRecognitionPopup extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    recognition: PropTypes.object
  }

  static defaultProps = {
    recognition: null
  }

  constructor(props) {
    super(props)
    this.state = {
      show: modalStory(modals, null),
      recognition: props.recognition || EMPTY_RECOGNITION(props.formatMessage)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.recognition && (nextProps.recognition !== this.state.recognition)) {
      this.setState({recognition: nextProps.recognition})
    }
  }

  // looks for any active popups, if none; we know its a new instance of popup so clear recognition
  shouldClearRecognition = () => !anyStoriesOpen(this.state.show)

  createAgain = () => {
    this.setState(({show}) => ({
      recognition: EMPTY_RECOGNITION(this.props.formatMessage),
      show: modalStory(modals, CREATE, show)
    }))
  }

  show = (modalToShow = CREATE) => {
    this.setState(({recognition, show}) => ({
      show: modalStory(modals, modalToShow, show),
      recognition: this.shouldClearRecognition() ? EMPTY_RECOGNITION(this.props.formatMessage) : recognition
    }))
  }

  hide = () => {
    this.setState({show: modalStory(modals, null)})
  }

  cancelConfirm = () => {
    const {recognition} = this.state
    const {formatMessage} = this.props

    if (isEqual(recognition, EMPTY_RECOGNITION(formatMessage))) {
      this.hide()
    } else {
      this.show(CANCEL_CONFIRM)
    }
  }

  handleChange = (recognition, key, value) => {
    const {formatMessage} = this.props
    const user = authentication.user()

    let newRecognition = {
      ...recognition,
      [key]: value
    }

    const canBeSharedWithTeams = isShareableWithTeams(user, newRecognition)

    if (!canBeSharedWithTeams && newRecognition.share.value === TEAMS) {
      newRecognition = {
        ...newRecognition,
        share: PRIVATE_OPTION(formatMessage)
      }
    }

    this.setState({
      recognition: newRecognition
    })
  }

  render() {
    const {recognition, show} = this.state
    const onChange = this.handleChange

    return (
      <>
        <TitleInlineModal show={(show[CREATE])} onHide={this.cancelConfirm}>
          <Create
            onChange={onChange}
            recognition={recognition}
            selectScreen={this.show} />
        </TitleInlineModal>
        <TitleInlineModal show={(show[SUCCESS])} onHide={this.hide}>
          <Success
            onClickButton={this.createAgain}
            onHide={this.hide} />
        </TitleInlineModal>
        <Modal show={show[CANCEL_CONFIRM]}>
          <CancelConfirm
            previous={show.previous}
            selectScreen={this.show}
            onHide={this.hide} />
        </Modal>
      </>
    )
  }
}

export default injectIntl(CreateRecognitionPopup, {withRef: true})
